import * as React from 'react';

function Sailing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.59 14.852c.968 2.74.222 4.508-2.237 5.307-3.69 1.197-16.353.98-16.353.195 0-.525.528-1.572 1.583-3.144 2.112 0 4.798-.079 8.058-.236 3.26-.156 6.244-.864 8.949-2.122zm-7.507-5.5c0-4.863-4.08-6.792-2.375-6.269 6.334 1.945 8.709 7.78 8.709 9.725 0 1.945-11.875 3.89-9.5 1.945.775-.635 3.166-3.142 3.166-5.402zm-3.958-3.144l-.792 8.644H6.167l3.958-8.644z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Sailing;
